<template>
	<div class="location-button">
		<button @click="$emit('locateMe')" :class="{selected:showingMe}" v-if="!showingMe"><div class="dot"></div>Var är jag?</button>
		<button @click="$emit('zoomAll')" :class="{selected:showingAll}" v-if="!showingAll"><font-awesome-icon :icon="['fas', 'route']" class="route" />Hela banan</button>
		<button @click="about"><font-awesome-icon :icon="['fas', 'info']" class="info" />Om kartan</button>
	</div>
</template>

<script>

import Vue from "vue"

export default Vue.extend({

	props: {
		"showingMe": Boolean,
		"showingAll": Boolean,
	},

	methods: {
		about() {
			this.$router.push(this.$route.path + "/about")
		}
	}
})
</script>

<style scoped>
	.location-button {
		position: absolute;
		bottom: 130px;
		left: 0;
		right: 0;

		display:flex;
		flex-flow: row nowrap;
		justify-content: center;
		z-index: 900000000;
		pointer-events: none;
	}

	.location-button button {
		cursor: pointer;
		font-family: 'Geomanist', sans-serif;
		font-weight: 700;
		font-size: 16px;
		background: white;
		background: #ffffffaa;
		border: none;
		border-radius: 30px;
		padding: 3px 12px;
		margin: 0 2px;
		pointer-events: auto;
	}

	.location-button button:focus {
		outline: none;
		/* box-shadow: 0px 0px 4px black; */
	}

	.location-button button:hover {
		background-color: white;
	}

	.location-button button.selected {
		opacity: .4;
	}

	.location-button button img {
		width: 22px;
		margin-right: 3px;
	}

	.dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #1da1f2;
		margin-right: 5px;
	}

	.route {
		color: #666;
		margin-right: 5px;
	}

	.info {
		color: #666;
		margin-right: 5px;
	}
</style>